import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

export const Tooltip = ({ children, message, offset = 8 }) => {
  
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0, placement: "top" });
  const ref = useRef(null);
  const tooltipRef = useRef(null);
  const hideTimeout = useRef(null);

  const updatePosition = () => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const tooltipHeight = 200;
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;

    const placement = spaceAbove > tooltipHeight + offset ? "top" : "bottom";

    const top =
      placement === "top"
        ? rect.top + window.scrollY - offset
        : rect.bottom + window.scrollY + offset;

    const left = rect.left + window.scrollX + rect.width / 2;
    setCoords({ top, left, placement });
  };

  const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current);
    updatePosition();
    setShow(true);
  };

  const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => setShow(false), 150);
  };

  useEffect(() => {
    if (!show) return;
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);
    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [show]);

  if(!message){
    return <>{children}</>
  }

  return (
    <>
      <span
        ref={ref}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-block w-full"
      >
        {children}
      </span>

      {show &&
        createPortal(
          <div
            ref={tooltipRef}
            onMouseEnter={() => clearTimeout(hideTimeout.current)}
            onMouseLeave={handleMouseLeave}
            className={`fixed z-[9999] transform -translate-x-1/2 ${
              coords.placement === "top" ? "-translate-y-full mb-2" : "mt-2"
            }
              px-3 py-2 text-xs text-white bg-black/90 dark:bg-gray-950 
              rounded-lg shadow-lg w-[220px] max-w-[300px] break-words
              overflow-y-auto max-h-[200px]
              scrollbar-thin scrollbar-thumb-gray-400 
              dark:scrollbar-thumb-gray-600 scrollbar-track-transparent
              transition-opacity duration-150`}
            style={{
              top: coords.top,
              left: coords.left,
            }}
          >
            {message}
            <div
              className={`absolute left-1/2 -translate-x-1/2 border-4 border-transparent ${
                coords.placement === "top"
                  ? "top-full border-t-black/90 dark:border-t-gray-800"
                  : "bottom-full border-b-black/90 dark:border-b-gray-800"
              }`}
            />
          </div>,
          document.body
        )}
    </>
  );
};
